import { formatToToman } from "core/utils/format";
import { Actions } from "./Actions";

export const columns = [
  {
    Header: "شناسه",
    width: 50,
    accessor: "id",
    disableFilters: true,
  },
  {
    Header: "شماره سفارش",
    accessor: "orderNumber",
  },
  {
    Header: "قیمت",
    accessor: (row: any) => `${row.productPrice} ریال`,
  },
  {
    Header: "وضعیت سفارش",
    accessor: "orderStatusTitle",
  },
  {
    Header: "عملیات",
    accessor: "operations",
    disableFilters: true,
    width: 100,
    Cell: Actions,
  },
];
